var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 14.5C16.75 14.9142 17.0858 15.25 17.5 15.25C17.9142 15.25 18.25 14.9142 18.25 14.5H16.75ZM7.75 16V19H9.25V16H7.75ZM10 21.25H18V19.75H10V21.25ZM18 13.75H10V15.25H18V13.75ZM18 15.25C18.4142 15.25 18.75 15.5858 18.75 16H20.25C20.25 14.7574 19.2426 13.75 18 13.75V15.25ZM18 21.25C19.2426 21.25 20.25 20.2426 20.25 19H18.75C18.75 19.4142 18.4142 19.75 18 19.75V21.25ZM7.75 19C7.75 20.2426 8.75736 21.25 10 21.25V19.75C9.58579 19.75 9.25 19.4142 9.25 19H7.75ZM9.25 16C9.25 15.5858 9.58579 15.25 10 15.25V13.75C8.75736 13.75 7.75 14.7574 7.75 16H9.25ZM11.25 14.5V11H9.75V14.5H11.25ZM16.75 11V14.5H18.25V11H16.75ZM14 8.25C15.5188 8.25 16.75 9.48122 16.75 11H18.25C18.25 8.65279 16.3472 6.75 14 6.75V8.25ZM11.25 11C11.25 9.48122 12.4812 8.25 14 8.25V6.75C11.6528 6.75 9.75 8.65279 9.75 11H11.25ZM20.25 19V16H18.75V19H20.25Z",
    fill: "#050022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5H15.5",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b2a2eb9ad0b4b143a03e45ccd24f9c34.svg";
export { ForwardRef as ReactComponent };